/** Join class name strings together */
export function classNames(...classes: (string | null | boolean | undefined)[]): string {
    return classes.filter(Boolean).join(" ");
}
